"use client";

import { useState } from "react";

interface BookCoverProps {
  title: string;
  src: string;
  className?: string;
}

// Cover image with a branded gradient fallback if the placeholder art fails to
// load (offline, blocked, or 404). The fallback shows the book title so a cover
// is always meaningful rather than blank.
export default function BookCover({ title, src, className }: BookCoverProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className={`flex h-full w-full items-center justify-center bg-gradient-to-br from-space-cadet via-ultra-violet to-rose-quartz p-4 ${
          className ?? ""
        }`}
      >
        <span className="line-clamp-4 text-center text-lg font-semibold leading-snug text-isabelline">
          {title}
        </span>
      </div>
    );
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      alt={title}
      className={`h-full w-full object-cover ${className ?? ""}`}
      onError={() => setFailed(true)}
      src={src}
    />
  );
}
